import { useEffect, useState } from "react";

function SectionCandidatesSidebar({ filters, onChange, categories }) {
    const handleCategoryChange = (e) => {
        onChange({ ...filters, category: e.target.value, subcategory: "" });
    };

    const handleSubcategoryChange = (e) => {
        onChange({ ...filters, subcategory: e.target.value });
    };

    const handleTextChange = (e) => {
        onChange({ ...filters, [e.target.name]: e.target.value });
    };

    return (
        <div className="side-bar">
            <div className="sidebar-elements search-bx">
                <form onSubmit={(e) => e.preventDefault()}>
                    <div className="form-group mb-4">
                        <h4 className="section-head-small mb-4">Category</h4>
                        <select className="form-control" name="category" value={filters.category || ""} onChange={handleCategoryChange}>
                            <option value="">All Categories</option>
                            {categories.filter(c => !c.parent_id).map(c => <option key={c.id} value={c.slug || c.id}>{c.name}</option>)}
                        </select>
                    </div>

                    <div className="form-group mb-4">
                        <h4 className="section-head-small mb-4">Subcategory</h4>
                        <select className="form-control" name="subcategory" value={filters.subcategory || ""} onChange={handleSubcategoryChange} disabled={!filters.category}>
                            <option value="">All Subcategories</option>
                            {categories.filter(c => c.parent_id && (c.parent_id === categories.find(parent => parent.slug === filters.category || parent.id === filters.category)?.id)).map(c => <option key={c.id} value={c.slug || c.id}>{c.name}</option>)}
                        </select>
                    </div>

                    <div className="form-group mb-4">
                        <h4 className="section-head-small mb-4">Keyword</h4>
                        <div className="input-group">
                            <input type="text" name="keyword" className="form-control" placeholder="Skills, headline, etc." value={filters.keyword || ""} onChange={handleTextChange} />
                            <span className="input-group-text"><i className="feather-search" /></span>
                        </div>
                    </div>

                    <div className="form-group mb-4">
                        <h4 className="section-head-small mb-4">Location</h4>
                        <div className="input-group">
                            <input type="text" name="location" className="form-control" placeholder="Search location" value={filters.location || ""} onChange={handleTextChange} />
                            <span className="input-group-text"><i className="feather-map-pin" /></span>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default SectionCandidatesSidebar;
